/**
 * Ingredients Data
 * 
 * Contains all ingredient information used throughout the application.
 */

export interface IngredientBenefit {
  title: string;
  description: string;
}

export interface Ingredient {
  name: string;
  desc: string;
  image: string;
  benefits: IngredientBenefit[];
}

export const INGREDIENTS: Ingredient[] = [
  {
    name: "N-Acetylcysteine",
    desc: "Antioxidant support (600mg)",
    image: "/images/ingredients/N-Acetylcysteine.webp",
    benefits: [
      {
        title: "Antioxidant Support",
        description: "Supports antioxidant defences"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "Ashwagandha",
    desc: "Supports stress response (300mg)",
    image: "/images/ingredients/Ashwagandha.webp",
    benefits: [
      {
        title: "Stress Response",
        description: "Supports the body's stress response"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "L-Theanine",
    desc: "Supports relaxation (200mg)",
    image: "/images/ingredients/L-Theanine.webp",
    benefits: [
      {
        title: "Relaxation",
        description: "Supports relaxation"
      },
      {
        title: "Mental Focus",
        description: "Supports mental focus"
      }
    ]
  },
  {
    name: "Milk Thistle",
    desc: "Supports general wellbeing (250mg)",
    image: "/images/ingredients/Milk Thistle.webp",
    benefits: [
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "Turmeric",
    desc: "Antioxidant support (450mg)",
    image: "/images/ingredients/Turmeric.webp",
    benefits: [
      {
        title: "Antioxidant Support",
        description: "Supports antioxidant activity"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "Zinc",
    desc: "Supports immune function (15mg)",
    image: "/images/ingredients/Zinc.webp",
    benefits: [
      {
        title: "Immune Function",
        description: "Supports immune system function"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "Electrolytes",
    desc: "Supports hydration (1000mg)",
    image: "/images/ingredients/Electrolytes.webp",
    benefits: [
      {
        title: "Hydration",
        description: "Supports hydration and fluid balance"
      },
      {
        title: "Mineral Balance",
        description: "Supports mineral balance"
      }
    ]
  },
  {
    name: "Vitamin B-Complex",
    desc: "Supports energy levels (100mg)",
    image: "/images/ingredients/Vitamin B-Complex.webp",
    benefits: [
      {
        title: "Energy Levels",
        description: "Supports energy levels"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  },
  {
    name: "Vitamin C",
    desc: "Supports immune system (1000mg)",
    image: "/images/ingredients/Vitamin C.webp",
    benefits: [
      {
        title: "Immune Support",
        description: "Supports immune system function"
      },
      {
        title: "Antioxidant Support",
        description: "Supports antioxidant defences"
      }
    ]
  },
  {
    name: "Magnesium",
    desc: "Supports muscle function (200mg)",
    image: "/images/ingredients/Magnesium.webp",
    benefits: [
      {
        title: "Muscle Function",
        description: "Supports muscle function"
      },
      {
        title: "General Wellbeing",
        description: "Supports general health and wellbeing"
      }
    ]
  }
];